import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import OmnisendCRUDActions from '../actions/OmnisendCRUDActions';
import { OmnisendAccessToken } from '../model/ConnectionModel';
import { OmnisendModel } from '../model/OmnisendModel';

type ActionType = {
  type: string;
  accounts: OmnisendAccessToken[];
  account: OmnisendAccessToken;
};

const initialState: OmnisendModel = {
  busy: false,
  accounts: [],
};

export const omnisend = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case OmnisendCRUDActions.busyAction:
      return setBusy(state);

    case OmnisendCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: action.accounts,
        busy: false,
      };
    }
    case OmnisendCRUDActions.retrievedAccessToken: {
      const { accounts } = state;
      const accountsIndex = accounts.findIndex(
        account => account.id === action.account.id,
      );
      let newAccounts;
      if (accountsIndex >= 0) {
        newAccounts = Object.assign([], accounts, {
          [accountsIndex]: { ...action.account, readOnly: false },
        });
      } else {
        newAccounts = [{ ...action.account, readOnly: false }, ...accounts];
      }
      return {
        ...state,
        busy: false,
        accounts: newAccounts,
      };
    }
    case OmnisendCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
